import React, { useEffect, useState } from 'react';
import { Container, Card, Table } from 'react-bootstrap';
import { apiService, Usuario } from '../services/api';

const Usuarios: React.FC = () => {
  const [usuarios, setUsuarios] = useState<Usuario[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const resp = await apiService.getUsuarios({ per_page: 100 });
        if (resp.estado === 1 && resp.registros) setUsuarios(resp.registros);
      } catch (e) { console.error(e); }
    })();
  }, []);

  return (
    <Container fluid>
      <Card className="shadow-sm border-0 mb-3">
        <Card.Header className="bg-primary text-white">
          <h5 className="mb-0"><i className="fas fa-users me-2"></i> Usuarios</h5>
        </Card.Header>
      </Card>
      <Card className="shadow-sm border-0">
        <Card.Body className="p-0">
          <Table responsive hover size="sm" className="mb-0">
            <thead className="table-light"><tr>
              <th>ID</th><th>Nombre</th><th>Usuario</th><th>Tipo</th><th>Estado</th>
            </tr></thead>
            <tbody>
              {(Array.isArray(usuarios) ? usuarios : []).map(u => (
                <tr key={u.id_usuario}>
                  <td>{u.id_usuario}</td>
                  <td>{u.nombre_usuario} {u.apellido_usuario || ''}</td>
                  <td>{u.nick_usuario}</td>
                  <td>{u.tipo}</td>
                  <td>{u.estado === 1 ? 'Activo' : 'Inactivo'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Usuarios;
